/**
 * nowe typy ról - bez starych!
 * @type {{REPORT_WRITE: string, REPORT_READ: string, BILLING: string, DEVICE_PIGLET_CAGE: string, USER_MANAGE: string, DEVICE_COUNTER: string, DEVICE_FEEDING: string, GENERAL_READ: string, DEVICE_CLIMATE: string, BUILDING: string, REPORTS: string, DEVICE_CHAIN: string, BREEDING: string, DEVICE_CONFIG: string, DEVICE_CAGE: string, DEVICE_SILO: string}}
 */
const RoleTypes = {
    GENERAL_READ: "_GENERAL_READ",
    BREEDING: "_BREEDING",
    REPORT_WRITE: "_REPORT_WRITE",
    REPORT_READ: "_REPORT_READ",
    REPORTS: "_REPORT",
    BUILDING: "_BUILDING",
    BILLING: "_BILLING",
    USER_MANAGE: "_USER_MANAGE",
    SERVICE: "_SERVICE",
    MASTER_SERVICE: "_MASTER_SERVICE",
    TRANSLATION: "_TRANSLATION",
    ITS: "_ITS",
    ITS_READ: "_ITS_READ",
    ITS_WRITE: "_ITS_WRITE",
    ITS_HISTORY: "_ITS_HISTORY",
    FILES: "_FILES",
    SALE_READ: "_SALE_READ",
    SALE_WRITE: "_SALE_WRITE",
    DEVICE_CAGE_READ: "_DEVICE_CAGE_READ",
    DEVICE_FARM_WATCH_PRO_READ: "_DEVICE_FARM_WATCH_PRO_READ",
    DEVICE_SILO_READ: "_DEVICE_SILO_READ",
    DEVICE_FEEDING_READ: "_DEVICE_FEEDING_READ",
    DEVICE_IPSUM_READ: "_DEVICE_IPSUM_READ",
    DEVICE_NUTRI_PRO_READ: "_DEVICE_NUTRI_PRO_READ",
    DEVICE_CLIMATE_READ: "_DEVICE_CLIMATE_READ",
    DEVICE_CHAIN_READ: "_DEVICE_CHAIN_READ",
    DEVICE_PIGLET_CAGE_READ: "_DEVICE_PIGLET_CAGE_READ",
    DEVICE_COUNTER_READ: "_DEVICE_COUNTER_READ",
    DEVICE_CAGE_WRITE: "_DEVICE_CAGE_WRITE",
    DEVICE_SILO_WRITE: "_DEVICE_SILO_WRITE",
    DEVICE_FEEDING_WRITE: "_DEVICE_FEEDING_WRITE",
    DEVICE_IPSUM_WRITE: "_DEVICE_IPSUM_WRITE",
    DEVICE_NUTRI_PRO_WRITE: "_DEVICE_NUTRI_PRO_WRITE",
    DEVICE_CLIMATE_WRITE: "_DEVICE_CLIMATE_WRITE",
    DEVICE_CHAIN_WRITE: "_DEVICE_CHAIN_WRITE",
    DEVICE_PIGLET_CAGE_WRITE: "_DEVICE_PIGLET_CAGE_WRITE",
    DEVICE_COUNTER_WRITE: "_DEVICE_COUNTER_WRITE",
    DEVICE_FARM_WATCH_PRO_WRITE: "_DEVICE_FARM_WATCH_PRO_WRITE",
    DEVICE_CONFIG: "_DEVICE_CONFIG",
    ECONOMY_READ: "_ECONOMY_READ",
    ECONOMY_WRITE: "_ECONOMY_WRITE",
    AI_READ: "_ARTIFICIAL_INTELLIGENCE_READ",
    AI_WRITE: "_ARTIFICIAL_INTELLIGENCE_WRITE",
    FARM_MAP_READ: "_FARM_MAP_READ",
    FARM_MAP_WRITE: "_FARM_MAP_WRITE",
    SUPPORT: "_SUPPORT",
    ANALYSIS_READ: "_ANALYSIS_READ",
    ANALYSIS_WRITE: "_ANALYSIS_WRITE",
};

module.exports = RoleTypes;
